import { render, staticRenderFns } from "./PricingModal.vue?vue&type=template&id=42096480&scoped=true"
import script from "./PricingModal.vue?vue&type=script&lang=js"
export * from "./PricingModal.vue?vue&type=script&lang=js"
import style0 from "./PricingModal.vue?vue&type=style&index=0&id=42096480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42096480",
  null
  
)

export default component.exports